import React, { useState, useEffect } from 'react';
// import CardContainer from '../../../components/card/card-container.jsx';
import Api from '../../../api/global.service';
import env from '../../../environment.js';
import BlockUi from 'react-block-ui';
import LabelCategory from '../../../components/label/label-category.jsx';
import { publish } from '../../../components/events.js';
import formatNumber from '../../../utils/formatNumber.js';
import { useCoopConfig, getIdCatCreditoPrecosecha, getUsaEstimacionManual } from '../../../components/content/coop-config.jsx';
import transformWord from '../../../utils/transformWord.js';
import LabelEudrProducer from '../../../components/label/label-eudr-prod.jsx';
import unidadAcopioConvertible from '../../../utils/unidadAcopioConvertible.js';
import useEudrProdRisk from '../../../hooks/useEudrProdRisk.js';
import useCreditosData from '../../../hooks/useCreditosData.js';

const EntregasXProductorInfo = ({ uuid_cuenta, id_cuenta }) => {
  const coopConfig = useCoopConfig();

  const [getDataBlocking, setGetDataBlocking] = useState(true);
  const [cuenta, setCuenta] = useState([]);
  const [fotoURL, setFotoURL] = useState(false);
  const [fotoOpen, setFotoOpen] = useState(false);
  const [estimacion, setEstimacion] = useState();
  const [entregas, setEntregas] = useState([]);
  const [pagos, setPagos] = useState([]);
  const [etiquetaAnticipos, setEtiquetaAnticipos] = useState('-');
  const { riesgoEudr } = useEudrProdRisk({ productor_id: id_cuenta });
  const { creditos, blockingCreditos } = useCreditosData({
    uuid_cuenta,
    id_ciclo: localStorage.getItem(`${env.appName}-ciclo_id`),
    publishEvent: 'Entrega::Creditos',
  });

  const blocking = getDataBlocking || blockingCreditos;

  useEffect(() => {
    getEtiquetaAnticipo();
  }, [coopConfig.config]);

  const getEtiquetaAnticipo = async () => {
    let etiqueta = await coopConfig.etiquetaAnticipos();
    setEtiquetaAnticipos(etiqueta);
  };

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    Api.get('admin/acopios/entregas/acopios_por_productor/' + localStorage.getItem(`${env.appName}-ciclo_uuid`), uuid_cuenta)
      .then(response => {
        setGetDataBlocking(false);
        if (typeof response.data[0] !== 'undefined') {
          let _cuenta = {
            cuenta_categoria: response.data[0].cuenta_categoria,
            cuenta_categoria_color: response.data[0].cuenta_categoria_color,
            productor_clave_tx: response.data[0].productor_clave_tx,
            productor_codigo_tx: response.data[0].productor_codigo_tx,
            productor_id: response.data[0].productor_id,
            productor_nombre: response.data[0].productor_nombre,
            productor_uuid: response.data[0].productor_uuid,
            region: response.data[0].region,
            localidad: response.data[0].localidad,
            municipio: response.data[0].municipio,
            id_centro_acopio: response.data[0].id_centro_acopio,
          };
          let _entregas = {
            entregas_no: response.data[0].entregas_no,
            entregas_no_bultos: response.data[0].entregas_no_bultos,
            entregas_peso_neto_total: response.data[0].entregas_peso_neto_total,
            precio_por_kg_promedio: response.data[0].precio_por_kg_promedio,
          };

          let _pagos = {
            pagos_descuentos_total: response.data[0].pagos_descuentos_total,
            pagos_pagado_total: response.data[0].pagos_pagado_total,
            pagos_total: response.data[0].pagos_total,
          };

          let _estimacion = {
            est_peso_estimado_total: getUsaEstimacionManual()
              ? response.data[0].est_peso_estimado_manual_total
              : response.data[0].est_peso_estimado_total,
            est_peso_estimado_total_original: getUsaEstimacionManual()
              ? response.data[0].est_peso_estimado_manual_total_original
              : response.data[0].est_peso_estimado_total_original,
            // est_peso_estimado_total_nueva_estructura: response.data[0].est_peso_estimado_total_nueva_estructura,
            est_entregado_vs_estimacion: response.data[0].est_entregado_vs_estimacion,
          };

          setCuenta(_cuenta);
          setEntregas(_entregas);
          setEstimacion(_estimacion);
          setPagos(_pagos);

          publish('Entrega::Cuenta', _cuenta);
          publish('Entrega::Entregas', _entregas);
          publish('Entrega::Estimacion', _estimacion);
          publish('Entrega::Pagos', _pagos);
        }
        setGetDataBlocking(false);
      })
      .catch(() => {
        setGetDataBlocking(false);
      });
  };

  const getEstimacionVsEntregas = (estimado, entregado) => {
    let result = 0;
    if (estimado > 0 && entregado) {
      result = formatNumber((entregado / estimado) * 100);
    }
    return result;
  };

  const getSaldoEntregas = (pagos_total, pagos_descuentos_total, pagos_pagado_total) => {
    return formatNumber((pagos_total || 0) - (pagos_descuentos_total || 0) - (pagos_pagado_total || 0));
  };

  return (
    <div
      className="col-xl-12 col-lg-12"
      style={{
        backgroundColor: env.colors.neutral_10,
        border: `1px solid ${env.colors.neutral_border}`,
        borderRadius: 14,
        paddingBottom: 16,
      }}>
      <BlockUi tag="div" message="" blocking={blocking || blockingCreditos} renderChildren={true}>
        <div className="row">
          <div className="col-xl-5 col-6 text-center">
            {fotoURL ? (
              <button type="button" className="btn" style={{ borderRadius: '20px 20px 20px 20px' }} onClick={() => setFotoOpen(!fotoOpen)}>
                <img src={`${env.apiURL}/${fotoURL}`} className="profile_productor"></img>
              </button>
            ) : (
              <img src={env.images.profile.productor} />
            )}
          </div>

          <div className="col-xl-7 col-6">
            <div className="row" style={{ paddingTop: 16 }}>
              <div className="col-xl-12 col-12">
                <h6 className="font-lato-normal-400">Productor:</h6>
              </div>
              <div className="col-xl-12 col-12">
                <h4 className="font-lato-normal-500 pb-3">{cuenta?.productor_nombre}</h4>
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 5,
                  padding: '2px 5px',
                  borderRadius: '5px',
                  justifyContent: 'space-between',
                  flexWrap: 'wrap',
                }}>
                <LabelCategory label={cuenta?.cuenta_categoria} color={cuenta?.cuenta_categoria_color}></LabelCategory>
                {riesgoEudr ? <LabelEudrProducer riesgo={riesgoEudr} preLabel="EUDR: " /> : null}
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-4 col-5 offset-1">{cuenta?.productor_clave_tx}</div>
          <div className="col-xl-7 col-6">{cuenta?.municipio}</div>
        </div>
        <div className="row">
          <div className="col-xl-4 col-5 offset-1">{cuenta?.productor_codigo_tx}</div>
          <div className="col-xl-7 col-6">{cuenta?.localidad}</div>
        </div>

        <div className="btn-entregas-acopios">Información de entregas y acopio</div>

        <div className="pl-4 pt-3">
          <div className="row">
            <div className="col-xl-8 col-12 info-entregas-titulo">
              {'Entregas pasadas (' + formatNumber(entregas?.entregas_no || 0) + ')'}
            </div>
            {/*
                  <div className='col-xl-4 info-entregas-link'>
                    {'Ver recibos'}
                  </div>
                */}
          </div>

          <div className="row">
            <div className="col-xl-8 col-7 info-entregas-variable">{'Nº envases'}</div>
            <div className="col-xl-4 col-5 info-entregas-variable">{entregas?.entregas_no_bultos}</div>
          </div>

          <div className="row">
            <div className="col-xl-8 col-7 info-entregas-variable">{'Peso neto total'}</div>
            <div className="col-xl-4 col-5 info-entregas-variable">
              {unidadAcopioConvertible(entregas?.entregas_peso_neto_total, coopConfig)}
            </div>
          </div>
        </div>

        <div className="pl-4 pt-3">
          <div className="row">
            <div className="col-xl-12 info-entregas-titulo">{'Estimación de cosecha'}</div>
          </div>

          <div className="row">
            <div className="col-xl-8 col-7 info-entregas-variable">{'Peso estimado total'}</div>
            <div className="col-xl-4 col-5 info-entregas-variable">
              {/* {unidadAcopioConvertible(estimacion?.est_peso_estimado_total, coopConfig)} */}
              {coopConfig.hasAcopioUnitsExtra()
                ? `${formatNumber(estimacion?.est_peso_estimado_total_original || 0)} ${coopConfig.acopioUnitsExtra()?.abreviacion}`
                : `${formatNumber(estimacion?.est_peso_estimado_total || 0)} ${coopConfig.acopioUnits()?.abreviacion}`}
            </div>
          </div>

          <div className="row">
            <div className="col-xl-8 col-7 info-entregas-variable">{'% entregado vs. estimación'}</div>
            <div className="col-xl-4 col-5 info-entregas-variable">
              {getEstimacionVsEntregas(estimacion?.est_peso_estimado_total || 0, entregas?.entregas_peso_neto_total) + ' %'}
            </div>
          </div>
        </div>

        <div className="pl-4 pt-3">
          <div className="row">
            <div className="col-xl-12 info-entregas-titulo">{'Pagos totales'}</div>
          </div>

          <div className="row">
            <div className="col-xl-8 col-7 info-entregas-variable">{'Precio promedio a productor'}</div>
            <div className="col-xl-4 col-5 info-entregas-variable">
              {`${coopConfig.currency()?.symbol}/${
                coopConfig.hasAcopioUnitsExtra() ? coopConfig.acopioUnitsExtra()?.abreviacion : coopConfig.acopioUnits()?.abreviacion
              }  `}
              {unidadAcopioConvertible(entregas?.precio_por_kg_promedio, coopConfig, false, true)}
            </div>
          </div>

          <div className="row">
            <div className="col-xl-8 col-7 info-entregas-variable">{'Importe total'}</div>
            <div className="col-xl-4 col-5 info-entregas-variable">
              {coopConfig.currency()?.symbol + ' ' + formatNumber(pagos?.pagos_total || 0)}
            </div>
          </div>
          {coopConfig.mostrarCreditoPrecosecha() && (
            <div className="row">
              <div className="col-xl-8 col-7 info-entregas-variable">{'Descuentos deudas'}</div>
              <div className="col-xl-4 col-5 info-entregas-variable">
                {coopConfig.currency()?.symbol + ' ' + formatNumber(pagos?.pagos_descuentos_total || 0)}
              </div>
            </div>
          )}

          <div className="row">
            <div className="col-xl-8 col-7 info-entregas-variable">{'Pagado a productor'}</div>
            <div className="col-xl-4 col-5 info-entregas-variable">
              {coopConfig.currency()?.symbol + ' ' + formatNumber(pagos?.pagos_pagado_total || 0)}
            </div>
          </div>

          <div className="row">
            <div className="col-xl-8 col-7 info-entregas-variable">{'Saldo de las entregas'}</div>
            <div className="col-xl-4 col-5 info-entregas-variable">
              {coopConfig.currency()?.symbol +
                ' ' +
                getSaldoEntregas(pagos?.pagos_total || 0, pagos?.pagos_descuentos_total || 0, pagos?.pagos_pagado_total || 0)}
            </div>
          </div>
        </div>
        {getIdCatCreditoPrecosecha() > 1 && creditos?.creditos_no > 0 && (
          <div className="pl-4 pt-3">
            <div className="row">
              <div className="col-xl-8 col-6 info-entregas-titulo">
                {transformWord(etiquetaAnticipos, ['plural', 'capitalize']) +
                  ' precosecha (' +
                  formatNumber(creditos?.creditos_no || 0) +
                  ')'}
              </div>
              <div className="col-xl-4 col-6 info-entregas-link">{''}</div>
            </div>

            <div className="row">
              <div className="col-xl-8 col-7 info-entregas-variable">{'Importe total'}</div>
              <div className="col-xl-4 col-5 info-entregas-variable">
                {coopConfig.currency()?.symbol + ' ' + formatNumber(creditos?.creditos_total || 0, 2)}
              </div>
            </div>

            <div className="row">
              <div className="col-xl-8 col-7 info-entregas-variable">{'Saldo del ' + transformWord(etiquetaAnticipos, ['singular'])}</div>
              <div className="col-xl-4 col-5 info-entregas-variable">
                {coopConfig.currency()?.symbol + ' ' + formatNumber(creditos?.total_saldo || 0)}
              </div>
            </div>
          </div>
        )}
      </BlockUi>
    </div>
  );
};

export default EntregasXProductorInfo;
